/**
 * VOTE
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentVote {

	private $parent: any;

	private articleId: string;

	private _id: string;

	private commentId: string;

	private _$this: any;

	private selector: string;

	constructor( $parent: any, articleId: string ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.selector = `#${this._id} .ncCommentCommonWrap .co-btn-like`;
		this.articleId =  articleId || Util.getParams().articleId;
		this.addEvent();
	}

	public setChangeUI( data: any ) {
		if ( data !== -1 ) {
			this._$this.find( '.text' ).text( data );
		}
	}

	public vote() {
		const _data: any = {};
		const _method = 'POST';

		_data.board = Config.board;
		_data.articleId = this.articleId;
		_data.commentId = this.commentId;

		const _post = Util.get( Config.voteComment( _data ), _method );
		_post.then( ( data: any ) => {
			if ( data.result || data.result === '0' ) {
				data = data.result;
			}

			if ( data !== -1 ) {
				this.setChangeUI( data );
				this._$this.addClass( 'is-active' );
			} else if ( data === -1 ) {
				this.voteCancel();
			}

			this.enabled();

		}, ( data: any ) => {
			Config.apiError( data );

			this.enabled();
		});
	}

	public voteCancel() {
		const _post = Util.get( Config.voteComment({
			board: Config.board,
			articleId: this.articleId,
			commentId: this.commentId,
		}), 'DELETE');
		_post.then( ( data: any ) => {

			if ( data.result || data.result === '0' || data.result === 0 ) {
				data = data.result;
			}

			if ( data !== -1 ) {
				this._$this.removeClass( 'is-active' );
				this.setChangeUI( data );
			} else if ( data === -1 ) {
				this._$this.removeClass( 'is-active' );
				this.vote();
			}

			this.enabled();

		}, ( data: any ) => {

			Config.apiError( data );

			this.enabled();
		});
	}

	public disabled() {
		jQuery( this.selector ).prop( 'disabled', true );
	}

	public enabled() {
		// @TODO 1초 딜레이 - 부하 이슈 대응
		setTimeout( () => {
			jQuery( this.selector ).prop( 'disabled', false );
		}, 1000 );
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', this.selector, ( evt: any ) => {
			this.disabled();

			this._$this = jQuery( evt.currentTarget );
			this.commentId = this._$this.attr( 'data-commentid' );

			this.vote();
		});
	}
}

export default CommentVote;
